module.exports = __webpack_public_path__ + "media/homepage/forbes-logo-58dfe7bd.svg";